// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1wTqF","amount":"Amount_amount__2Svzg","tip":"Amount_tip__37Ns2","tipHeader":"Amount_tipHeader__2c9FG","tipsWrap":"Amount_tipsWrap__2OaYA"};